<!-- Toast notifications -->
<p-toast key="main"></p-toast>

<!-- Modern Header Section -->
<div class="m-4">
  <div class="sales-orders-header">
    <div class="header-content">
      <div class="header-left">
        <h1 class="sales-orders-title">
          <i class="pi pi-shopping-cart mr-3"></i>
          Sales Orders
        </h1>
        <p class="sales-orders-subtitle">
          View and manage sales orders for clinics
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Main Content Area -->
<div class="sales-orders-content">
  <div class="content-section">
    <div class="section-header">
      <div class="header-info">
        <h2 class="section-title">Order Management</h2>
        <p class="section-description">View and manage sales orders for clinics</p>
      </div>
    </div>

    <div class="filter-section">
      <div class="filter-header">
        <h3 class="filter-title">
          <i class="pi pi-filter"></i>
          Filter Orders
        </h3>
        <p class="filter-description">Filter sales orders by clinic, order number, and date range</p>
      </div>
      <form [formGroup]="filterForm" class="filter-form">
        <div class="filter-row">
          <div class="filter-field">
            <label class="filter-label">Clinic</label>
            <p-dropdown
              [options]="clinics"
              optionLabel="name"
              optionValue="id"
              placeholder="Select Clinic"
              styleClass="modern-dropdown"
              [filter]="true"
              filterBy="name"
              emptyMessage="No clinics found"
              appendTo="body"
              class="z-10"
              formControlName="clinic_id"
              [showClear]="true"
            >
            </p-dropdown>
          </div>
          
          <div class="filter-field">
            <label class="filter-label">Order Number</label>
            <p-dropdown
              [options]="orders"
              [filter]="true"
              filterBy="order_number"
              optionLabel="order_number"
              optionValue="order_number"
              placeholder="Select Order"
              styleClass="modern-dropdown"
              formControlName="order_number"
              class="z-10"
              style="z-index: 100;"
              [showClear]="true"
              >
            </p-dropdown>
          </div>
        </div>
        
        <div class="filter-row">
          <div class="filter-field">
            <label class="filter-label">From Date</label>
            <p-calendar
              formControlName="date_from"
              placeholder="Select start date"
              dateFormat="yy-mm-dd"
              styleClass="modern-calendar"
              appendTo="body"
              [showClear]="true"
            ></p-calendar>
          </div>
          
          <div class="filter-field">
            <label class="filter-label">To Date</label>
            <p-calendar
              formControlName="date_to"
              placeholder="Select end date"
              dateFormat="yy-mm-dd"
              styleClass="modern-calendar"
              appendTo="body"
              [showClear]="true"
            ></p-calendar>
          </div>
        </div>
        
        <div class="filter-actions">
          <button
            pButton
            pRipple
            [label]="exportLoading ? 'Exporting...' : 'Export Orders'"
            [icon]="exportLoading ? 'pi pi-spinner pi-spin' : 'pi pi-file-excel'"
            class="modern-button primary ml-4"
            [class.loading]="exportLoading"
            [disabled]="exportLoading"
            (click)="exportOrders()"
          ></button>
        </div>
      </form>
    </div>

    <div class="table-container p-4">
      <p-table
        #salesOrdersTable
        [value]="orders"
        [lazy]="true"
        [rows]="10"
        [paginator]="true"
        (onLazyLoad)="lazyLoadOrders($event)"
        [scrollable]="true"
        scrollHeight="50vh"
        [totalRecords]="metaData.totalRecords"
        [rowsPerPageOptions]="[10, 25, 50, 100]"
        [loading]="metaData.loading"
        class="modern-table"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} orders"
      >
        <ng-template pTemplate="caption">
          <div class="">
            <div>
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                name="globalFilter"
                (input)="salesOrdersTable.filterGlobal(getFilterInputValue($event), 'contains')"
                placeholder="Search orders..."
                class=""
              />
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr class="table-header">
            <th *ngFor="let col of orderColumns" [pSortableColumn]="col.field">
              <div class="header-cell">
                {{ col.header }}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </div>
            </th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-order>
          <tr class="table-row" style="cursor: pointer" (click)="openSalesOrderDetails(order)">
            <td *ngFor="let col of orderColumns" class="table-cell">
              <div class="cell-content">
                <span *ngIf="col.field === 'order_date' || col.field === 'date_required'">{{ order[col.field] | date : "yyyy-MM-dd" }}</span>
                <span *ngIf="col.field === 'order_total'">{{ order[col.field] | currency : "R" : "symbol" }}</span>
                <span *ngIf="col.field !== 'order_date' && col.field !== 'date_required' && col.field !== 'order_total'">{{ resolveField(order, col.field) }}</span>
              </div>
            </td>
            <td></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="orderColumns.length + 1" class="empty-state">
              <p-progressBar *ngIf="metaData.loading" mode="indeterminate"></p-progressBar>
              <div *ngIf="!metaData.loading" class="empty-content">
                <i class="pi pi-shopping-cart empty-icon"></i>
                <h3>No orders found</h3>
                <p>No sales orders are currently available</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
